import React from 'react';
import { useStateContext } from '../../../../context/ContextProvider';
import ColorLandingPage from '../../../LandingPages/ColorLandingPage';
import { neonMap, textMap } from '../../../../components/ColorMappingOptions';

function FePeacehomesSkyline({
    language
}) {
    const color = "rose";

    const images = [
        "/assets/images/projects/peacehomes-skyline/1.webp",
        "/assets/images/projects/peacehomes-skyline/2.webp",
        "/assets/images/projects/peacehomes-skyline/3.webp",
        "/assets/images/projects/peacehomes-skyline/4.webp",
        "/assets/images/projects/peacehomes-skyline/5.webp"
    ];

    const poster = "/assets/images/projects/peacehomes-skyline/poster.jpg";
    // const webm = "/assets/images/projects/peacehomes-skyline/hero.webm";
    const video = "/assets/images/projects/peacehomes-skyline/video.mp4";

    const {
        langs,
        langCode,
        userInfo,
        FINDESTATES_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isIraq = userInfo?.countryName == "Iraq";
    const isIran = userInfo?.countryName == "Iran";
    const isTurkey = userInfo?.countryName == "Turkey";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className="text-center text-xl lg:text-2xl font-bold neon-white">
                        <span className={`${textMap[color]} ${neonMap[color]}`}>
                            الوحدات محدودة ..
                        </span>
                        &nbsp;
                        سجل بياناتك الأن
                    </h1>
                ) : (
                    <h1 className="font-bold text-center text-xl">
                        <span className={`text-2xl ${textMap[color]} ${neonMap[color]}`}>
                            Limited Units Available...
                        </span>
                        <br />
                        Register your details now!
                    </h1>
                )}

            </>
        );
    }

    const gridDetails = [
        {
            "topic": "أنواع الوحدات",
            "text": "استوديو 3,2,1 غرفة",
        },
        {
            "topic": "الأسعار تبدأ من",
            "text": isUAE ? "655,000 درهم" : "180 ألف دولار",
        },
        {
            "topic": "أقساط شهرية",
            "text": isUAE ? "6600 درهم" : "1800 دولار",
        },
    ];

    const imageDetails = {
        "title": language == "ar" ? "✨ عرض حصري لفترة محدودة ✨" : "✨ Limited-Time Exclusive Offer ✨",
        "desc": language == "ar" ? "احجز وحدتك الآن واستمتع بمطبخ مجهز بالكامل بجميع الأجهزة الكهربائية" : "Book your unit now and enjoy a fully equipped kitchen with all electrical appliances."
    };

    return (
        <>
            {/* LANGUAGE */}
            {/* <LanguageNavigate
                    support={["en", "ar", "fa", "tr"]}
                    redirect={{
                        en: "/projects/azizi/venice",
                        ar: "/projects/azizi/venice/ar",
                        fa: "/projects/azizi/venice/fa",
                        tr: "/projects/azizi/venice/tr",
                    }}
                /> */}
            <ColorLandingPage
                color={color}
                // language={language}
                poster={poster}
                video={video}
                images={images}
                heading={<Heading />}
                gridDetails={gridDetails}
                imageDetails={imageDetails}
                projectName={"Skyline"}
                base_url={FINDESTATES_URL}
                developer="Peace Homes"
                project="Skyline"
                leadType="Apartment"
                language={language === "ar" ? "Arabic" : language === "fa" ? "Farsi" : language === "tr" ? "Turkish" : "English"}
                enquiries={["Studio", "1 Bedroom", "2 Bedrooms"]}
                jacuzzi={true}
                // assignedToManager={language == "fa" ? 120 : null}
                // assignedToSales={language == "fa" ? 518 : null}
                contactTime={isUSA || isCanada ? true : false}
                otpCode={6}
            />
        </>
    );
}

export default FePeacehomesSkyline;
